import { Component, OnInit } from '@angular/core';
import { OrganisationsService } from '../../services';

@Component({
  templateUrl: './org-structure-main.component.html',
})
export class OrgStructureMainComponent implements OnInit {
  tabIndex: number = 0;
  public id: number;
  public customerorgId: number;
  public msgs: any[];

  constructor(private orgService: OrganisationsService) {}

  ngOnInit() {
    this.orgService.getCurrentUserOrgTypeId().then((res) => {
      this.customerorgId = res;
      console.log('this.customerorgTYPEId');
      console.log(this.customerorgId);
    });
  }

  tabChange(e) {
    this.tabIndex = e.index;
  }
}
